if (!customElements.get('sticky-cta')) {
  customElements.define(
    'sticky-cta',
    class StickyCta extends HTMLElement {
      connectedCallback() {
        const target = this.dataset.target;
        const pageLinks = Array.from(document.querySelectorAll('a[href]')).filter(
          (link) => !this.contains(link) && link.getAttribute('href') === target
        );
        const watched = [...pageLinks, document.querySelector('footer')].filter(Boolean);

        // Show only while no other button to the same place (and not the footer) is on screen.
        this.visible = new Set();
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.visible.add(entry.target);
            else this.visible.delete(entry.target);
          });
          this.update();
        });
        watched.forEach((element) => this.observer.observe(element));
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      update() {
        const show = this.visible.size === 0;
        this.classList.toggle('is-visible', show);
        this.toggleAttribute('inert', !show);
      }
    }
  );
}
